import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useGetUserQuery } from 'common'
import { useFetchCollectionQuery, useFetchEventTypesCollectionQuery } from 'hooks/reporting/api'
import { currentOrganizationSelector } from 'selectors/current_organization'

import { COLLECTION_NAME } from '../constants'
import { init } from '../slice'

export const useFetchCollections = ({ skipInitialFetch = false }) => {
  const dispatch = useDispatch()

  const { data: currentUser } = useGetUserQuery()
  const { uri: organization } = useSelector(currentOrganizationSelector)
  const params = { organization, currentUserId: currentUser.id }

  const {
    data: groupsCollection,
    isLoading: isGroupsLoading
  } = useFetchCollectionQuery({ ...params, name: COLLECTION_NAME.GROUPS }, { skip: skipInitialFetch })
  const {
    data: teamsCollection,
    isLoading: isTeamsLoading
  } = useFetchCollectionQuery({ ...params, name: COLLECTION_NAME.TEAMS }, { skip: skipInitialFetch })
  const {
    data: usersCollection,
    isLoading: isUsersLoading
  } = useFetchCollectionQuery({ ...params, name: COLLECTION_NAME.USERS }, { skip: skipInitialFetch })
  const {
    data: eventTypesCollection,
    isLoading: isEventTypesLoading
  } = useFetchEventTypesCollectionQuery({ ...params, name: COLLECTION_NAME.EVENT_TYPES, page: 1 }, { skip: skipInitialFetch })

  const isCollectionsLoading = isGroupsLoading || isTeamsLoading || isUsersLoading || isEventTypesLoading

  const isInitialized = useRef(false)
  useEffect(() => {
    if (!isInitialized.current && !isCollectionsLoading) {
      dispatch(init({
        groupsCollection,
        teamsCollection,
        usersCollection,
        eventTypesCollection
      }))
      isInitialized.current = true
    }
  }, [isCollectionsLoading, dispatch, isInitialized, groupsCollection, teamsCollection, usersCollection, eventTypesCollection])
}
